import Vue from 'vue'
import axios from 'axios'
import { Notification,Message } from 'element-ui'
import router from '../router'
import {i18n} from '../i18n';
Vue.prototype.global_huanjing = {
  uploadApi:process.env.UPLOADURL,
  h5url:process.env.H5URL
};
// 全局定义axios参数
function axiosInitFun(){
  const localToken = localStorage.getItem('token')
  let axiosInit=axios.create({
    baseURL: process.env.DYNAMIC_BASE_URL,
    timeout: 120*1000,
    headers: {
      token: localToken
    },
    withCredentials: true
  })
  axiosInit.interceptors.response.use(function (response) {
    const data = response.data
    const contentDisposition = response.headers['content-disposition'];
    // console.log("11111111111111111111");
    if(data==='undefined'||data===''){
      Message.error(i18n.t('m.network_busy'))
    }
    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      // 文件下载
      return response;
    }
    if (data.code === 1) {
      return response
    } else {
      if (data.code === 500){
        // console.log("3333333333333");
        if (data.message == "401") {
          Notification.error({
            title: i18n.t('m.tip'),
            message: i18n.t('m.token_invalid'),
            duration: 0,
            position:i18n.locale=='ar'?"top-left":"top-right",
          })
          router.push({
            path: '/login?code=' + 401,
            query: {
              code: 401
            }
          })
        }else if(data.message=="402") {
          Notification.error({
            message: i18n.t('m.your_agency_been_forcibly'),
            duration: 3000
          })
          router.push({
            path: '/login',
            query: {
              code: 401
            }
          })
        }else{
          // Message.error(data.message)
          Message.error(i18n.t('m.network_busy'))
        }
      }else if (data.code == 403) {
        // 没有权限, 转向上一页
        router.go(-1);
        Message.error(data.message)
      }else{
        Message.error(data.message||data.msg)
      }
      return Promise.reject(data)
    }
  }, function (error) {
    if(error.message=='timeout of 30000ms exceeded'||error.message==='Network Error'){
      Message.error(i18n.t('m.network_busy'))
    }
    // let data = error.response.data;
    // if(data.code===500&&data.message==401){

    // }
    // else if(data.code===500&&data.message==402) {
    //   Notification.error({
    //     message: i18n.t('m.your_agency_been_forcibly'),
    //     duration: 3000
    //   })
    //   router.push({
    //     path: '/login',
    //     query: {
    //       code: 401
    //     }
    //   })
    // }
    return Promise.reject(error)
  })
  return axiosInit;
}

export const newClient = function () {
  return axiosInitFun();

}



// WEBPACK FOOTER //
// ./src/api/axios-client-factory.js